export const RootsConst = {
    directive: '/formulaire-public/public/ts/directives/'
};


// WEBPACK FOOTER //
// ./formulaire-public/src/main/resources/public/ts/core/constants/roots.const.ts